import clsx from 'clsx';
import React from 'react';

function CustomInput(props) {
  const { isError, errorMessage, label, prefix, isSolid, ...restProps } = props;
  return (
    <div>
      <div
        className={clsx('form-input', {
          'with-prefix': Boolean(prefix)
        })}>
        {prefix && <span className="prefix text-blue-1">{prefix}</span>}
        <input
          {...restProps}
          className={clsx('fs-6', { 'border-danger': isError }, { 'bg-white': isSolid })}
        />
        <label htmlFor="unknown" className="lh-1 text-14 text-light-1 fw-500">
          {label}
        </label>
      </div>
      {isError && errorMessage && (
        <span className="text-danger text-14 fw-normal">{errorMessage}</span>
      )}
    </div>
  );
}

export default CustomInput;
